class MainMenuNav {
  constructor() {
    this.currentId = null // ID of current nav button and menu popup (desktop)
    this.headerNavButtons = document.querySelectorAll('#header .list-item-button')
    this.menuPopupDivs = document.querySelectorAll('#header .menu-popup')
    this.menuOverlay = document.querySelector('#main-menu-overlay')

    // Register event for nav button click
    this.headerNavButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation()
        this.handleNavBtnClick(button.id)
      })
    })

    // Register event for click outside menu popup
    document.addEventListener('click', (e) => {
      e.stopPropagation()

      if (this.currentId && e.target.id === 'main-menu-overlay') {
        this.hideMenuPopup()
      }
    })

    // Register event for escape key press
    document.addEventListener('keyup', (e) => {
      e.stopPropagation()

      if (e.key === 'Escape') {
        if (this.currentId) {
          // Desktop only
          this.hideMenuPopup()
        } else if (this.isMobileMenuOpen()) {
          // Mobile only
          this.hideMobileMenu()
          this.resetMobileMenu()
        } else if (this.isSearchActive()) {
          // To close the desktop search bar with escape key
          this.closeSearchForm()
        }
      }
    })

    /**
     * Search form stuff
     */
    this.searchToggle = document.querySelector('#header .search-toggle__btn')
    this.searchForm = document.querySelector('#header .search-form')
    this.searchInput = document.querySelector('#header #SearchForm_SearchForm_q')
    this.searchFormContainer = document.querySelector('#header .search-form-outer')

    // Used to move the search form back to desktop position
    this.headerContainer = document.querySelector('#header .header-container')

    // Used to move the search form to mobile position
    this.searchFormMobileContainer = document.querySelector('#mobile-search-container')

    // Register event for search button click
    this.searchToggle.addEventListener('click', (e) => {
      e.stopPropagation()
      this.handleSearchBtnClick(e)
    })

    /**
     * Mobile nav stuff
     */
    // HTML elements
    this.mobileHeader = document.querySelector("#header")
    this.mobileMenuBtn = document.querySelector('#header #mobile-menu-btn')
    this.mobileMenuWrapper = document.querySelector('#header .mobile-menu-wrapper')
    this.mobileMenuNavButtons = document.querySelectorAll('#header .mobile-menu__nav-btn')
    this.mobileMenuItems = document.querySelectorAll('#header .mobile-menu__item')
    this.mobileHeaderLinks = document.querySelector('#header .header-links-mobile')
    this.mobileHeaderMenuInsides = document.querySelectorAll('#header .mobile-menu__inside')
    this.mobileMenuBackBtns = document.querySelectorAll('#header .mobile-menu__back-btn')

    // Is mobile menu level2 open, if yes, what id
    this.activeMobileLevel2Menu = null

    // Register event for mobile menu button
    this.mobileMenuBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      this.mobileMenuBtnClick(e)
    })

    document.addEventListener('focusin', (event) => {
      if (this.isMobileMenuOpen()
          && !this.mobileMenuWrapper.contains(event.target)) {
        this.hideMobileMenu()
        this.resetMobileMenu()
      }
    })

    // Register event for mobile nav button click
    this.mobileMenuNavButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation()
        this.handleMobileNavBtnClick(button.id)
      })
    })

    // Register event for mobile nav button click
    this.mobileMenuBackBtns.forEach(button => {
      button.addEventListener('click', (e) => {
        e.stopPropagation()
        this.resetMobileMenu()
      })
    })

    /**
     * Code for detecting current page and highlighting active nav button
     */
    addEventListener('load', () => {
      // Read the 'page-id' data attribute from body tag
      const pageId = document.body.getAttribute('data-page-id')

      if (pageId) {
        this.headerNavButtons?.forEach((btn) => {
          // Extract the id number from the button id (nav-button_{$ID})
          const btnIdNum = btn.id?.slice(btn.id?.indexOf('_') + 1)

          // If they match then add '--on' modifier to add underline, remove if not
          if (btnIdNum === pageId) {
            btn.classList.add('list-item-button--on')
          } else {
            btn.classList.remove('list-item-button--on')
          }
        })
      }
    })

    // Register event for window resize
    // Close the menu/search when resized
    addEventListener('resize', (event) => {
      if (this.currentId) {
        // Desktop only
        this.hideMenuPopup()
      } else if (this.isMobileMenuOpen()) {
        // Mobile only
        this.hideMobileMenu()
        this.resetMobileMenu()
      } else if (this.isSearchActive()) {
        this.closeSearchForm()
      }
    })
  }

  /**
   * Moves the search form (.search-form-outer) to required position in DOM depending on mobile or desktop.
   * @param {String} position
   */
  moveSearchFormTo(position) {
    if (position === 'mobile') {
      this.searchFormMobileContainer.appendChild(this.searchFormContainer)
    } else if (position === 'desktop') {
      this.headerContainer.appendChild(this.searchFormContainer)
    }
  }

  /**
   * Takes you back to the first page of the mobile menu
   */
  resetMobileMenu() {
    // id can be 0 which is falsy
    if (this.activeMobileLevel2Menu !== null) {
      // Update all mobileMenuItems
      this.mobileMenuItems.forEach(item => {
        // Set all items to default view (do opposite to handleMobileNavBtnClick())
        item.querySelector(`.mobile-menu__nav-btn`).classList.remove('mobile-menu__nav-btn--hide')
        item.querySelector(`.mobile-menu__inside`).classList.remove('mobile-menu__inside--on')
        item.classList.remove('mobile-menu__item--hide')
      })

      // Hide the header-links
      this.mobileHeaderLinks?.classList.remove('header-links-mobile--hide')

      // Reset the current open mobile level2 menu
      this.activeMobileLevel2Menu = null
    }
  }

  /**
   * Handle mobile level-1 menu item click
   * @param {Number} btnId
   */
  handleMobileNavBtnClick(btnId) {
    // Extract $ID from the element ID
    const id = btnId.slice(btnId.indexOf('_') + 1)

    // Save the current open mobile menu
    this.activeMobileLevel2Menu = id

    // Update all mobileMenuItems
    this.mobileMenuItems.forEach(item => {
      if (item.id === `mobile-menu-item_${id}`) {
        // Hide the .mobile-menu__nav-btn that matches the id
        item.querySelector(`.mobile-menu__nav-btn`)?.classList.add('mobile-menu__nav-btn--hide')

        // Show the 2nd level menu that matches the id
        item.querySelector(`.mobile-menu__inside`)?.classList.add('mobile-menu__inside--on')

        item.querySelector(`.mobile-menu__back-btn`)?.focus()
      } else {
        // Hide all .mobile-menu__item elements that don't match id
        item.classList.add('mobile-menu__item--hide')
      }
    })

    // Hide the header-links
    this.mobileHeaderLinks?.classList.add('header-links-mobile--hide')
  }

  /**
   * Handle hamburger menu button
   */
  mobileMenuBtnClick() {
    this.toggleSearch(true) // Need to tell if mobile (true) or desktop (false)
    this.moveSearchFormTo('mobile')
    this.toggleMobileMenu()
  }

  /**
   * Handle logic behind mobile menu
   */
  toggleMobileMenu() {
    if (!this.isMobileMenuOpen()) {
      // Open mobile menu
      this.mobileMenuWrapper.classList.add('mobile-menu-wrapper--on')

      // We need to disable scroll the body content
      document.body.classList.add('no-scroll')

      // Set attributes role="dialog" aria-modal="true" to the header
      this.mobileHeader.setAttribute("role", "dialog")
      this.mobileHeader.setAttribute("aria-modal", true)
    } else {
      this.hideMobileMenu()
    }

    // Reset the current open mobile menu
    this.resetMobileMenu()
  }

  /**
   * Check if mobile menu is open
   * @returns {Boolean}
   */
  isMobileMenuOpen() {
    return this.mobileMenuWrapper.classList.contains('mobile-menu-wrapper--on')
  }

  /**
   * Close the mobile menu, if active
   */
  hideMobileMenu() {
    if (this.isMobileMenuOpen()) {
    // Close mobile menu
    this.mobileMenuWrapper.classList.remove('mobile-menu-wrapper--on')

    // Enable scroll on body again
    document.body.classList.remove('no-scroll')

    // Set attributes role="dialog" aria-modal="true" to the header
    this.mobileHeader.removeAttribute("role")
    this.mobileHeader.removeAttribute("aria-modal")

    // Hide the search form
    this.closeSearchForm()
    }
  }

  /**
   * Is the search form open
   * @returns {Boolean}
   */
  isSearchActive() {
    return this.searchToggle.classList.contains('search-toggle__btn--on') ||
      this.mobileMenuBtn.classList.contains('mobile-menu-btn--on')
  }

  /**
   * Open or close the search form
   */
  toggleSearch(isMobile) {
    if (this.isSearchActive()) {
      this.closeSearchForm()
    } else {
      this.openSearchForm(isMobile)
    }
  }

  /**
   * Open the search form via CSS class
   */
  openSearchForm(isMobile) {
    // Show the search form holder
    this.searchFormContainer.classList.add('search-form-outer--on')

    // Desktop search button
    this.searchToggle.classList.add('search-toggle__btn--on')
    this.searchToggle.querySelector('.icon-search')?.classList.remove('mdi-magnify')
    this.searchToggle.querySelector('.icon-search')?.classList.add('mdi-close')
    this.searchToggle.ariaExpanded = true

    // Mobile menu button
    this.mobileMenuBtn.classList.add('mobile-menu-btn--on')
    this.mobileMenuBtn.querySelector('.mdi')?.classList.remove('mdi-menu')
    this.mobileMenuBtn.querySelector('.mdi')?.classList.add('mdi-close')
    this.mobileMenuBtn.ariaExpanded = true

    this.searchForm.classList.add('search-form--on')

    // Focus on the search field, but only for desktop
    if (!isMobile) {
      this.searchInput.focus()
    }
  }

  /**
   * Close the search form via CSS class
   */
  closeSearchForm() {
    // Hide the search form holder - causes extra 1px height in navbar
    this.searchFormContainer.classList.remove('search-form-outer--on')

    // Desktop search button
    this.searchToggle.classList.remove('search-toggle__btn--on')
    this.searchToggle.querySelector('.icon-search')?.classList.remove('mdi-close')
    this.searchToggle.querySelector('.icon-search')?.classList.add('mdi-magnify')
    this.searchToggle.ariaExpanded = false

    // Mobile menu button
    this.mobileMenuBtn.classList.remove('mobile-menu-btn--on')
    this.mobileMenuBtn.querySelector('.mdi')?.classList.add('mdi-menu')
    this.mobileMenuBtn.querySelector('.mdi')?.classList.remove('mdi-close')
    this.mobileMenuBtn.ariaExpanded = false

    this.searchForm.classList.remove('search-form--on')
    this.searchInput.blur()
  }

  /**
   * Change the search button to 'X' if search is active (desktop)
   */
  handleSearchBtnClick() {
    this.moveSearchFormTo('desktop')
    this.hideMenuPopup()
    this.toggleSearch()
  }

  /**
   * Handle logic for navigation buttons and open appropriate menu (desktop)
   * @param {Number} btnId
   */
  handleNavBtnClick(btnId) {
    const btn = document.querySelector(`#${btnId}`)
    const id = btnId.slice(btnId.indexOf('_') + 1) // extract $ID from the element ID (e.g. #nav-button_{$ID})

    if (btn && id) {
      // If click same button again then hide
      if (this.currentId === id) {
        this.hideMenuPopup()
      } else {
        this.currentId = id
        this.closeSearchForm() // Hide search
      }

      this.updateMenuPopup()
      this.updateButtons()
    }
  }

  /**
   * Updates button state, change the button icon (desktop - menu up/down)
   */
  updateButtons() {
    this.headerNavButtons.forEach(btn => {
      // Find the active button
      if (btn.id === `nav-button_${this.currentId}`) {
        btn.classList.add('list-item-button--on')

        // Set aria-expanded
        btn.ariaExpanded = true

        // Note: icon is inside the btn hence need the querySelector
        btn.querySelector('.mdi')?.classList.remove('mdi-menu-down')
        btn.querySelector('.mdi')?.classList.add('mdi-menu-up')
      } else {
        btn.classList.remove('list-item-button--on')

        // Set aria-expanded
        btn.ariaExpanded = false

        // Note: icon is inside the btn hence need the querySelector
        btn.querySelector('.mdi')?.classList.add('mdi-menu-down')
        btn.querySelector('.mdi')?.classList.remove('mdi-menu-up')
      }
    })
  }

  handleFocusOut(event, div) {
    event.stopPropagation()
    if (div.classList.contains('menu-popup--on')
        && !div.contains(event.relatedTarget)) {
      this.hideMenuPopup()
    }
  }

  /**
   * Updates menu popup state
   */
  updateMenuPopup() {
    this.menuPopupDivs.forEach(div => {
      if (div.id === `menu-popup_${this.currentId}`) {
        // Set popup to active
        div.classList.add('menu-popup--on')

        // Display overlay
        this.menuOverlay?.classList.add('overlay-displayed')

        div.addEventListener('focusout', (e) => this.handleFocusOut(e, div))
      } else {
        // Remove the active class
        div.classList.remove('menu-popup--on')
      }
    })
  }

  /**
   * Force the menu popup to disappear (desktop)
   */
  hideMenuPopup() {
    this.currentId = null
    this.menuOverlay?.classList.remove('overlay-displayed')

    this.updateMenuPopup()
    this.updateButtons()
  }
}

export default MainMenuNav
